<div class="offer-list-switch">
  <mat-slide-toggle class="map-view-toggle" color="primary" [checked]="mapView" (change)="toggleChange($event)">
    Widok mapy
  </mat-slide-toggle>

  @if (!mapView) {
    <div class="current-view-indicator">
      Jeśli chcesz zobaczyć oferty na mapie, przełącz suwak na aktywny.
    </div>
  }

  <!-- Map Controls moved here -->
  @if (mapView && isMobile) {
    <div class="map-controls">
      <div class="view-controls">
        @if (satelliteView) {
          <button mat-stroked-button color="primary" (click)="switchToNormalView()"
            [title]="'Zwykła mapa'">
            <mat-icon>map</mat-icon>
            <span class="button-text">Zwykła mapa</span>
          </button>
        }
        @if (!satelliteView) {
          <button mat-stroked-button color="primary" (click)="switchToSatelliteView()"
            [title]="'Widok satelitarny'">
            <mat-icon>satellite</mat-icon>
            <span class="button-text">Widok satelitarny</span>
          </button>
        }
        <button mat-stroked-button color="primary" (click)="showCurrentLocation(true)" [title]="'Pobierz lokalizację'">
          <mat-icon>my_location</mat-icon>
          <span class="button-text">Twoja lokalizacja</span>
        </button>
        <!--
        <button mat-stroked-button color="primary" (click)="useSavedLocation()" *ngIf="currentLocation"
          [title]="getSavedLocationInfo() || 'Zapisana lokalizacja'">
          <mat-icon>place</mat-icon>
          <span class="button-text">Użyj zapisanej</span>
        </button>
        -->
   
        <button mat-stroked-button color="primary" (click)="clearRoute()" [title]="'Wyczyść trasę'">
          <mat-icon>clear</mat-icon>
          <span class="button-text">Wyczyść trasę</span>
        </button>
      </div>
    </div>
  }
</div>

@if (!mapView) {
  <div class="offer-list-grid">
    @for (offer of offers; track offer) {
      <app-offer-view class="offer-item" [attr.data-offer-id]="offer.id" (click)="goToOfferDetails(offer.id)" [offer]="offer"></app-offer-view>
    }
  </div>
}

@if (mapView) {
  <div class="map-view-container">
    <!-- Map View Layout -->
    <div class="map-view-grid">
      <!-- Main Map Container -->
      <div class="map-container">
        <div id="map" style="width: 100%; height: 100%;"></div>
        <!-- Right Sidebar as Overlay Box (moved to right side) -->
        @if (visibleOffers.length > 0) {
          <div class="offers-sidebar-overlay" [class.hidden]="sidebarHidden">
            <div class="sidebar-header">
              <button mat-icon-button class="toggle-sidebar-btn" (click)="toggleSidebar()">
                <mat-icon>chevron_right</mat-icon>
              </button>
              <h3>Lista offert ({{ visibleOffers.length }})</h3>
            </div>
            <div class="sidebar-content">
              @for (offer of visibleOffers; track offer) {
                <div class="offer-item" (click)="focusOnOffer(offer)"
                  [class.selected]="selectedOfferId === offer.id">
                  @if (offer.file) {
                    <div class="offer-image">
                      <img [src]="imagesUrl + 'thumb/' + offer.file" [alt]="offer.title" />
                    </div>
                  }
                  <div class="offer-details">
                    <div class="offer-title">{{ offer.partner_name }}</div>
                    <div class="offer-location">
                      {{ offer.title }}
                    </div>
                    @if (offer.distance) {
                      <div class="offer-distance">
                        <mat-icon>directions_walk</mat-icon>
                        {{ offer.distance }}m
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- Toggle Button for Hidden Sidebar (moved to right side) -->
        @if (sidebarHidden) {
          <div class="sidebar-toggle-collapsed">
            <button mat-icon-button class="toggle-sidebar-btn-collapsed" (click)="toggleSidebar()">
              <mat-icon>chevron_left</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}

<div id="bottom-pointer"></div>